export const conditionCardShadow = (shadow) => {
    if (shadow) {
        return `
            border: none;
            box-shadow: var(--container-shadow-color-100);
        `;
    }
};
